import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgMic = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8 1a2.5 2.5 0 0 0-2.5 2.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8 1"
    />
    <path
      fill={_.color}
      d="M4 6.75a.75.75 0 0 0-1.5 0v.75c0 2.816 2.109 5.14 4.75 5.465v.535H5.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H8.75v-.535c2.641-.325 4.75-2.649 4.75-5.465v-.75a.75.75 0 0 0-1.5 0v.75a4 4 0 0 1-8 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMic);
export default ForwardRef;
